import Vue from 'vue';

export default {
  // 采购项目列表的状态查询
  getPurchaseListStatus (type) {
    return Vue.axios.get('/api/v1.0/chanquan/purchase/purchaseListStatus?type=' + type);
  },
  // 采购项目列表
  getPurchaseList (payload) {
    return Vue.axios.post('/api/v1.0/chanquan/purchase/purchaseList', payload);
  },
  // 采购项目详情
  getPurchaseProjectDetail (params) {
    return Vue.axios.get('/api/v1.0/chanquan/purchase/echo', {params});
  },
  // 采购项目报名
  purchaseProjectSignUp (payload) {
    return Vue.axios.post('/api/v1.0/chanquan/bid/sign', payload);
  },
  // 校验当前登录人是否报名
  checkCurrentUserSign (purchaseId) {
    return Vue.axios.get('/api/v1.0/chanquan/purchase/checkCurrentUserSign?purchaseId=' + purchaseId);
  },
  // 校验当前登录人是否报名
  checkCurrentUserSignForUnlogin (purchaseId) {
    return Vue.axios.get('/api/v1.0/chanquan/purchase/checkCurrentUserSignForUnlogin?purchaseId=' + purchaseId);
  },
  // 获取附件下载地址
  getDownloadAttachmentUrl (projectType) {
    return Vue.axios.get('/api/v1.0/chanquan/purchase/getDownloadAttachmentUrl?projectType=' + projectType);
  },
  // 获取合同下载和预览地址
  getProjectContractUrl(params) {
    return Vue.axios.get('/api/v1.0/chanquan/purchase/getContractUrlByProjectIdV2', {params: params});
  },
  // 检查是否购买文件费
  checkPayFileFeeByUser(purchaseId) {
    return Vue.axios.get('/api/v1.0/chanquan/purchase/checkPayFileFeeByUser/'+purchaseId);
  },
  // 获取支付信息
  getOrderDetaiByDeposit(params) {
    return Vue.axios.post('/api/v1.0/chanquan/bid/getOrderDetaiByDeposit', params);
  },
  // 获取支付信息
  getPaymentInfo(params) {
    return Vue.axios.post('/api/v1.0/chanquan/bid/getPayUrlCode', params);
  },
  // 获取VX交易结果
  getPaymentResult(transactionNo, type) {
    return Vue.axios.get('/api/v1.0/chanquan/bid/getPaymentResult/' + transactionNo + '/' + type);
  }
};
